import '../components/promoBlock/scripts';
import '../components/filteredProductList/scripts';
